import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteFreightClaimAttachmentsCall,
  physicalInventoryDate,
  postApproveRejectReconcilePhysicalInventory,
  postPhysicalInventory,
  postPhysicalInventoryIAU,
  uploadFreightClaimAttachmentsCall
} from "src/api/sp";

export const createPhysicalInventory = createAsyncThunk(
  "createPhysicalInventory",
  (payload: any) => postPhysicalInventory(payload)
);

export const physicalInventoryApprover = createAsyncThunk(
  "physicalInventoryApprover",
  (payload: any) => postApproveRejectReconcilePhysicalInventory(payload)
);

export const createPhysicalInventoryIAU = createAsyncThunk(
  "createPhysicalInvIAU",
  (payload: any) => postPhysicalInventoryIAU(payload)
);

export const physicalInventoryUploadApproverAttachments = createAsyncThunk(
  "physicalInventoryUploadApproverAttachments",
  (fcUploadAttachmentPayload: any) =>
    uploadFreightClaimAttachmentsCall(fcUploadAttachmentPayload)
);

export const deletePhysicalInventoryApproverAttachments = createAsyncThunk(
  "deletePhysicalInventoryApproverAttachments",
  (filePath: string) => {
    deleteFreightClaimAttachmentsCall(filePath);
  }
);

export const fetchPhysicalInventoryDate = createAsyncThunk(
  "fetchPhysicalInventoryDate",
  (props: { storeId: string }) => physicalInventoryDate(props)
);
